import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios"
Vue.config.productionTip = false

axios.defaults.params = {}
axios.defaults.params['crossDomain'] = true

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'http://localhost:7791/api/v1';
} else {
  axios.defaults.baseURL = 'https://api.dekaedge.dekapointsolutions.com/api/v1/';
}
axios.interceptors.request.use(function (config) {
  return Promise.resolve()
  .then(_=>{
    // console.log("Running attach", tokenResponse);
    config.headers.authorization = localStorage.getItem("token");
    return Promise.resolve(config)
  }).catch(error => {
    console.log(error);
    return Promise.resolve(config)
  })
});
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status == 401) {
    console.log("send me to login")
    router.push({"name":"home"})
  }
  return Promise.reject(error);
})

import loading from "./components/global/loading.vue"
import dialog from "./components/global/confirm.vue"

import vuetify from './plugins/vuetify';

Vue.component('v-loading',loading)
Vue.component('v-dialog',dialog)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
